<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/transplus_brokerage2.jpg')"
      />
      <div class="content-center">
        <div class="container">
          <h1
            class="title"
            v-html="$t('General.FreightBrokerage')"
          >
            Freight Brokerage<span class="tpgreen">.</span class="tpgreen"></span>
          </h1>
        </div>
      </div>
    </div>
        
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Freight.FreightBrokdesc1')"
            >
              We <span class="tpgreen">promote</span> cross-service <span class="tpgreen">collaboration.</span>
            </h2>
            <h5
              class="description"
              v-html="$t('Freight.FreightBrokdesc2')"
            >
              Our job is to make your life easier by embracing your unique business challenges. By working side by side with esteemed partners in warehousing, distribution, and transportation, we service from coast to coast to Canada and the U.S.
            </h5>
          </div> 
        </div>
      </div>
    </div> 
    <hr class="tpgreen">
    <!-- -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-11 ml-auto mr-auto text-center">
            <!-- <h2 class="title">We service a wide range of industries</h2> -->
            <div class="row">
              <div class="content-center col-md-4 ">
                <div style="color:dodgerblue">
                  <i class="fal fa-badge-dollar fa-6x" />
                </div>
                <h4
                  class="card-title"
                  v-html="$t('Freight.Rates')"
                >
                  Competitive Rates
                </h4>                  
              </div>
              
              <div class="content-center col-md-4 ">                  
                <div style="color:dodgerblue">
                  <i class="fal fa-handshake fa-6x" />
                </div>
                <h4
                  class="card-title"
                  v-html="$t('Freight.Carriers')"
                >
                  Pre-Approved Carriers
                </h4>                                                 
              </div>

              <div class="content-center col-md-4 ">
                <div style="color:dodgerblue">
                  <i class="fal fa-route-interstate fa-6x" />
                </div>
                <h4
                  class="card-title"
                  v-html="$t('Freight.Interstate')"
                >
                  U.S. Interstate
                </h4>                  
              </div>
            </div>
            <div class="row">
              <div class="content-center col-md-4 ">
                <div style="color:dodgerblue;">
                  <i class="fal fa-id-card-alt fa-6x" />
                </div>
                <h4
                  class="card-title"
                  v-html="$t('Freight.SinglePoint')"
                >
                  Single Point of Contact
                </h4>                  
              </div>
              

              <div class="content-center col-md-4 ">
                <div style="color:dodgerblue">
                  <i class="fal fa-user-clock fa-6x" />
                </div>
                <h4
                  class="card-title"
                  v-html="$t('Freight.Hours')"
                >
                  Flexible Hours
                </h4>                  
              </div>

              <div class="content-center col-md-4">
                <div style="color:dodgerblue">
                  <i class="fal fa-truck-moving fa-6x" />
                <!--<div class="text-center  ml-auto mr-auto"><i class="fal fa-truck-container fa-6x" style="padding-right:10px"></i> <i class="fal fa-truck-moving fa-6x"></i></div>-->
                </div>
                <h4
                  class="card-title"
                  v-html="$t('Freight.FTLLTL')"
                >
                  FTL and LTL
                </h4>                  
              </div>                              
            </div> 
          </div>
        </div>
      </div>
    </div>

    <hr class="tpgreen">

    <!-- We service a wide range of industries. -->
    <div class="section">
      <div
        class="container"
        style="max-width: 800px"
      >
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto  text-center">
            <h2
              class="title"
              v-html="$t('index.industry')"
            >
              We provide services to a wide range of <span class="tpgreen">industries.</span class="tpgreen"></span>
            </h2>
            <h5 class="description">
              These include:                
            </h5>
          </div>
        </div>

        <div class="row">
          <div
            v-for="{ imgSrc, text, fallback } in [
              {
                imgSrc: 'img/food.jpg',
                text: $t('General.FoodBeverage'),
                fallback: 'Food and Beverage',
              },
              {
                imgSrc: 'img/consumer.jpg',
                text: $t('General.ConsumerGoods'),
                fallback: 'Consumer Goods',
              },
              {
                imgSrc: 'img/ecom.jpg',
                text: $t('General.eCommerce'),
                fallback: 'eCommerce',
              },
              {
                imgSrc: 'img/manufacture.jpg',
                text: $t('General.Manufacturing'),
                fallback: 'Manufacturing',
              },              
              {
                imgSrc: 'img/medical2.jpg',
                text: $t('General.Health'),
                fallback: 'Healthcare',
              },
              {
                imgSrc: 'img/retail.jpg',
                text: $t('General.RetailDis'),
                fallback: 'Retail Distribution',
              },
              
            ]"
            :key="imgSrc"
            class="col-6 col-sm-4"
          >
            <div class="features-text">
              <div
                style="text-align: center"
                v-html="text"
              >
                {{ fallback }}
              </div>
            </div>

            <div style="padding-top: 100%; position: relative;">
              <div
                style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; background-size: cover; background-position: center; filter: grayscale(50%);"
                :style="{ 'background-image': `url(${imgSrc})` }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- -->
    <!--<div class="section gotoservices" >-->
    <div class="col-md-8 ml-auto mr-auto text-center">
      <!-- <a href="/quote" v-html="$t('General.getquotebusiness')">Get a quote for your business  <span class="tpgreen">→</span></a> -->
      <a
        class="nav-link requestaquote"
        href="/quote"
        style="color:white; text-transform: capitalize;"
      >{{ $t("navbar.quote") }}</a>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {};
  }
};
</script>
<style scoped>
.card-title{
  padding-bottom:40px
}
/*-- --*/
.imgservices{
  filter: grayscale(50%);
  width:200; 
  height:200px;
}
.imgautoheight{
  background-size: auto 200px;
}
.imgboxshadow{
  box-shadow: 1px 3px 14px 2px rgba(0,0,0,0.15);
}
/*-- */

.features-text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  font-size: 16px;
  min-height: 48px;
}

@media screen and (min-width: 322px) {
  .features-text {
    min-height: auto;
  }
}

@media screen and (min-width: 606px) {
  .features-text {
    font-size: 21px;
  }
}

@media only screen and (max-width: 600px) { 
  .page-header-small{
            min-height: 40vh;
            max-height: 440px;
    }
  .title{
    font-size:2.75em;
  }
}
</style>
